import SceneCommand from './SceneCommand';

import Sound from '../../entities/Sound';

import BackgroundMusicShowSceneCommandForm from '../../forms/scene_commands/BackgroundMusicShowSceneCommandForm';
import SceneCommandForm from '../../forms/scene_commands/SceneCommandForm';

export default class BackgroundMusicShowSceneCommand implements SceneCommand {
  constructor(public sound: Sound) {}

  public getValue() {
    return {
      sound_id: this.sound.id,
    };
  }

  public toForm(): SceneCommandForm {
    return new BackgroundMusicShowSceneCommandForm(this.sound);
  }
}
